export type ContextParameterName =
  | 'adUnitType'
  | 'inArticleType'
  | 'adsSetId'
  | 'executionEnvironment'
  | 'experienceId'
  | 'macros'
  | 'clickUrl'
  | 'click_url'
  | 'DSP_token'
  | 'impressionId'
  | 'creativeId'
  | 'campaignId'
  | 'creative_ratio'
  | 'click_strategy'
  | 'deviceOs'
  | 'is_programmatic';

export type ContextVariableName = 'context' | 'parameters';

type ContextMap = { [key: string]: ContextValue };
type ContextValue = string | number | ContextMap | boolean | undefined;
export type Context = {
  [key in ContextParameterName]?: ContextValue;
};
export type ContextAugmentedWindow = Window & {
  context: Context;
  parameters: ContextMap;
};

export class ParametersExtractor {
  public getWindowVariable<T>(varName: string, aWindow: Window): T {
    let currentWindow: Window | undefined = aWindow;

    while (
      currentWindow &&
      (!(currentWindow as any)[varName] ||
        (currentWindow as any)[varName] === undefined)
    ) {
      let parentWindow = this.getParentWindow(currentWindow);

      if (parentWindow === currentWindow) {
        break;
      }
      currentWindow = parentWindow;
    }

    return currentWindow && (currentWindow as any)[varName] !== undefined
      ? ((currentWindow as any)[varName] as T)
      : (undefined as T);
  }

  public getContextParameters<T extends ContextValue>(
    parameter: ContextParameterName,
    aWindow: Window,
    contextVariableName?: ContextVariableName
  ): T {
    let context = this.getAdContext(aWindow, contextVariableName);
    let currentWindow: Window | undefined = aWindow;

    while (currentWindow && (!context || context[parameter] === undefined)) {
      currentWindow = this.getParentWindow(currentWindow);
      context = this.getAdContext(currentWindow, contextVariableName);
    }

    return context && context[parameter] !== undefined
      ? (context[parameter] as T)
      : (undefined as T);
  }

  public getAdContext(
    aWindow: Window | undefined,
    contextVariableName: ContextVariableName = 'context'
  ): Context | undefined {
    if (!aWindow) {
      return undefined;
    }

    if (
      (aWindow as ContextAugmentedWindow)[contextVariableName] === undefined
    ) {
      return undefined;
    }

    return (aWindow as ContextAugmentedWindow)[contextVariableName];
  }

  public getParentWindow(aWindow: Window | undefined): Window | undefined {
    if (!aWindow) {
      return undefined;
    }
    if (!this.canAccessParentWindow(aWindow)) {
      return undefined;
    }

    return aWindow.parent;
  }

  public canAccessParentWindow(aWindow: Window): boolean {
    try {
      return (
        typeof aWindow.parent !== 'undefined' &&
        aWindow.parent.document !== undefined &&
        aWindow.parent !== aWindow
      );
    } catch (e) {
      // If an error occurs, it means we cannot access the parent window
      return false;
    }
  }
}
